<div class="box" (mouseenter)="showButtons(true)" (mouseleave)="showButtons(false)">
  @if ((size$ | async).more('m')) {
    <div>
      <button class="arrows"
        [disabled]="!firstCard"
        (click)="back()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button class="arrows arrow-right"
        [disabled]="lastCard === cardSettings.length - 1"
        (click)="forward()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      @if (isHovered && (lastCard - firstCard) < cardSettings.length - 1) {
        <div class="points"
          (wheel)="onWheel($event)">
          @for (item of cardSettings; track item) {
            <span>
              <mat-icon [ngClass]="{'visible-point': item.isVisible}">lens</mat-icon>
            </span>
          }
        </div>
      }
    </div>
  }
  <div class="container"
    #mainContainer
       [ngClass]="{'first-card': firstCard && (size$ | async).more('m'),
                   'container_le_l': (size$ | async).less('l')}">
    @if (!(unitData$ | async)?.unit) {
      <div class="loading">
        <span class="title">{{ (lastSelectedUnit$ | async).name }} </span>
        <span class="text">{{ 'term.loading' | translate }}</span>
        <span class="text">{{ '... ' }} </span>
        <mat-icon class="spinner">
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      </div>
    } @else {
      @if (cardSettings[0].isVisible || (size$ | async).less('l')) {
        <app-unit-info-card
          [width]="cardSettings[0].width"
          [unitData]="(unitData$ | async)"
        ></app-unit-info-card>
      }
      @if (cardSettings[1].isVisible || (size$ | async).less('l')) {
        <app-address-card
          [width]="cardSettings[1].width"
          [unitData]="(unitData$ | async)"
        ></app-address-card>
      }
      @if (cardSettings[2].isVisible || (size$ | async).less('l')) {
        <app-device-status-card
          [width]="cardSettings[2].width"
          [unitData]="(unitData$ | async)"
        ></app-device-status-card>
      }
      @if (cardSettings[3].isVisible || (size$ | async).less('l')) {
        <app-unit-status-card
          [width]="cardSettings[3].width"
          [unitData]="(unitData$ | async)"
        ></app-unit-status-card>
      }
      @if (cardSettings[4].isVisible || (size$ | async).less('l')) {
        <app-vehicle-card
          [width]="cardSettings[4].width"
          [unitData]="(unitData$ | async)"
        ></app-vehicle-card>
      }
      @if (cardSettings[5].isVisible || (size$ | async).less('l')) {
        <app-expire-info-card
          [width]="cardSettings[5].width"
          [unitData]="(unitData$ | async)"
        ></app-expire-info-card>
      }
      @if (cardSettings[6].isVisible || (size$ | async).less('l')) {
        <app-sensors-card
          [width]="cardSettings[6].width"
          [unitData]="(unitData$ | async)"
        ></app-sensors-card>
      }
      @if (cardSettings[7].isVisible || (size$ | async).less('l')) {
        <app-driver-card
          [width]="cardSettings[7].width"
          [unitData]="(unitData$ | async)"
        ></app-driver-card>
      }
      @if (cardSettings[8].isVisible || (size$ | async).less('l')) {
        <app-info-card
          [width]="cardSettings[8].width"
        ></app-info-card>
      }
    }

  </div>
</div>
